import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"70px","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_qrcode_stream = _resolveComponent("qrcode-stream")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isRequestPresence)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_qrcode_stream, {
      constraints: { facingMode: 'environment' },
      onDetect: $setup.onDetect,
      onError: $setup.onError,
      formats: $setup.barcodeFormats
    }, null, 8, ["onDetect", "onError", "formats"])
  ], 512)), [
    [_vShow, $setup.reloadQrCodeScan]
  ])
}